import { environmentHttpClient } from "../httpClient";
import { HubLinkedDocumentSaveModel } from "../Hub/common.composer";
import { DocumentLocationViewModel } from "../Hub/hubSettings";
import { UserIdentityModel } from "../UserProfile/service";
import { CommunityPostDetailsViewModel } from "./communityPostViewer";

export type CommunityPostSaveModel = {
	message: string;
	images: readonly CommunityPostImageSaveModel[];
	poll: OptionalModel<CommunityPostPollSaveModel | null>;
	linkedDocuments: readonly HubLinkedDocumentSaveModel[];
};

export const enum CommunityPostImageSaveModelKind {
	New = 1,
	Existing = 2
}

export type NewCommunityPostImageSaveModel = {
	kind: CommunityPostImageSaveModelKind.New;
	image: Base64FileUriUploadModel;
};

export type ExistingCommunityPostImageSaveModel = {
	kind: CommunityPostImageSaveModelKind.Existing;
	id: number;
};

export type CommunityPostImageSaveModel =
	| NewCommunityPostImageSaveModel
	| ExistingCommunityPostImageSaveModel;


export type CommunityPostPollAnswerSaveModel = {
	text: string;
};

export type CommunityPostPollSaveModel = {
	question: string;
	answers: readonly CommunityPostPollAnswerSaveModel[];
	isMultiSelect: boolean;
};

export function createCommunityPost(
	communityId: number,
	model: CommunityPostSaveModel,
	signal?: AbortSignal
): Promise<CommunityPostDetailsViewModel> {
	return environmentHttpClient.post<CommunityPostDetailsViewModel>(
		`/UiApi/Communities/${communityId}/Posts`,
		model,
		{ signal }
	);
}

export function editCommunityPost(
	postId: number,
	model: CommunityPostSaveModel,
	signal?: AbortSignal
): Promise<CommunityPostDetailsViewModel> {
	return environmentHttpClient.put<CommunityPostDetailsViewModel>(
		`/UiApi/Communities/Posts/${postId}`,
		model,
		{ signal }
	);
}

export function deleteCommunityPost(
	postId: number,
	signal?: AbortSignal
): Promise<void> {
	return environmentHttpClient.delete<void>(
		`/UiApi/Communities/Posts/${postId}`,
		undefined,
		{ signal }
	);
}

export type CommunityViewModel = {
	name: string;
	id: number;
};

export type CommunityPostOptionsModel = {
	supportedImageTypes: readonly string[];
	maxImageSize: number;
	supportedImageExtensions: readonly string[];
	defaultImageLocation: DocumentLocationViewModel | null;
};

export function listAuthors(
	signal?: AbortSignal
): Promise<readonly UserIdentityModel[]> {
	return environmentHttpClient.get<readonly UserIdentityModel[]>(
		`/UiApi/Communities/Posts/Authors`,
		undefined,
		{ signal }
	);
}

export type CommunityPostComposerViewModel = {
	options: CommunityPostOptionsModel;
	postableCommunities: readonly CommunityViewModel[];
};

export function getNewPostViewModel(
	signal?: AbortSignal
): Promise<CommunityPostComposerViewModel> {
	return environmentHttpClient.get<CommunityPostComposerViewModel>(
		"/UiApi/Communities/Posts/New",
		undefined,
		{ signal }
	);
}
